import { Button, TYPE_LINK } from '@eventbrite/eds-button';
import { GenericLazyString, gettext } from '@eventbrite/i18n';
import React from 'react';

interface SeeMoreButtonprops {
    /**
     * Title of parent bucket
     */
    title: string | GenericLazyString;
    /**
     * The url the user should be directed to
     */
    linkUrl: string;
    /**
     * The text the button should display
     */
    seeMoreText: string;
    /**
     * Tracking callback for button clicks
     */
    trackClick: () => void;
    /**
     * String representing user action to send to GA
     */
    gaAction: string;
    /**
     * String representing component display size; defaults to 'respnsive'
     */
    size: string;
}

export class SeeMoreButton extends React.PureComponent<SeeMoreButtonprops> {
    static defaultProps = {
        size: 'responsive',
    };

    render() {
        const {
            title,
            linkUrl,
            seeMoreText,
            trackClick,
            gaAction,
            size,
        } = this.props;
        const ariaLabel = seeMoreText
            ? seeMoreText
            : gettext('See more %(title)s', { title });
        const buttonLabel = seeMoreText ? seeMoreText : gettext('See more');

        let component = null;

        if (linkUrl) {
            component = (
                <Button
                    type={TYPE_LINK}
                    href={linkUrl}
                    onClick={trackClick.bind(null, { url: linkUrl }, gaAction)}
                    aria-label={ariaLabel}
                    size={size}
                >
                    {buttonLabel}
                </Button>
            );
        }

        return component;
    }
}
